import React from "react";
import { Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import MainLayout from "./components/Layouts/MainLayout.js";
// Screens
import Landing from "./screens/Landing.jsx";
import Login from "./screens/Login.jsx";
import Register from "./screens/Register.jsx";
import Mentors from "./screens/Mentors.jsx";
import Opportunities from "./screens/Opportunities.jsx";
import OpportunityDetails from "./screens/OpportunityDetails.jsx";
import Programs from "./screens/Programs.jsx";
import RequestDemo from "./screens/RequestDemo.jsx";
import FindTalent from "./screens/FindTalent.jsx";
import Internships from "./screens/Internships.jsx";
import InternshipDetails from "./screens/InternshipDetails.jsx";
import ProgramDetails from "./screens/ProgramDetails.jsx";
import Applications from "./screens/Applications.jsx";
import ConnectWithTalent from "./screens/ConnectWithTalent.jsx";
import MentorDetails from "./screens/MentorDetails.jsx";
import MyProfile from "./screens/MyProfile.jsx";
import VerifyOTP from "./screens/VerifyOtp.jsx";
import ResetPassword from "./screens/ResetPassword.jsx";
import RequestResetPassword from "./screens/RequestResetPassword.jsx";
import UserDashboard from "./screens/userDashboard.jsx";

export default function App() {
  return (
    <>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700;900&display=swap" rel="stylesheet"></link>
      </Helmet>
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Landing />} />
          <Route path="/home" element={<Landing />} />
          <Route path="/dashboard" element={<UserDashboard/>} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/mentors" element={<Mentors />} />
          <Route path="/mentors-detail" element={<MentorDetails />} />
          <Route path="/opportunities" element={<Opportunities />} />
          <Route path="/opportunities-detail" element={<OpportunityDetails />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/programs-detail" element={<ProgramDetails />} />
          <Route path="/request-demo" element={<RequestDemo />} />
          <Route path="/find-talent" element={<FindTalent />} />
          <Route path="/find-talent-connect" element={<ConnectWithTalent />} />
          <Route path="/internships" element={<Internships />} />
          <Route path="/internships-detail" element={<InternshipDetails />} />
          <Route path="/applications" element={<Applications />} />
          <Route path="/my-profile" element={<MyProfile />} />
          <Route path="/verify-otp" element={<VerifyOTP/>} />
          <Route path="/reset-password" element={<ResetPassword/>} />
          <Route path="/request-reset-password" element={<RequestResetPassword />} />
        </Route>
      </Routes>
    </>
  );
}

